import { colors, fontSizes } from '../../../Components/consts'
import { styled } from '@mui/system'

type BracketProps = {
  section?: 'bottom' | 'top'
  offset?: boolean
  justify?: 'center' | 'space-around'
  h?: number
  champion?: boolean
  hideSpacer?: boolean
  live?: boolean
}

type BoxProps = {
  isLive?: boolean
}

export const MatchupBoxCon = styled('div')<BoxProps>(({ isLive, theme }) => ({
  borderRadius: 2,
  border: `solid 1px ${isLive ? colors.green : colors.gray.gray70}`,
  width: 250,
  background: colors.gray.gray75,
  margin: theme.spacing(2, 0),
  [theme.breakpoints.between('md', 'lg')]: {
    width: 225,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: 165,
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    width: 115,
  },
  [theme.breakpoints.down('xs')]: {
    width: 100,
  },
  '& .teamRow': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `solid 0.5px ${colors.gray.gray70}`,
    background: colors.gray.gray80,
  },
  '& .gameInfo': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: colors.gray.gray40,
    borderBottom: `solid 1px ${colors.gray.gray60}`,
    padding: theme.spacing(0, 0.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 0.25),
    },
    '& .broadcastCon': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '& img': {
        width: 40,
        margin: '1px 3px',
        [theme.breakpoints.down('sm')]: {
          width: 30,
          margin: '1px',
        },
      },
    },
    '& p': {
      margin: 2,
      fontSize: '0.8rem',
      fontWeight: 700,
      color: colors.text,
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.6rem',
      },
    },
  },
}))

export const ChampInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0, 3),
  },
  '& .title': {
    borderRadius: '5px 5px 0 0',
    textAlign: 'center',
    width: '100%',
    padding: '10px 2px',
    background: colors.tan,
    '& h3': {
      margin: 0,
      fontSize: '1.5rem',
      fontWeight: 600,
      color: colors.text,
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9rem',
      },
    },
  },
  '& .champTeam': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    background: colors.tan,
    border: `solid 2px ${colors.lightGrey}`,
    borderRadius: ' 0 0 5px 5px',
    minHeight: 110,
    [theme.breakpoints.down('sm')]: {
      minHeight: 80,
    },
    '& img': {
      margin: 10,
      width: 70,
      [theme.breakpoints.down('sm')]: {
        margin: 5,
        width: 70,
      },
    },
  },
}))

export const TeamCon = styled('div')<BracketProps>(({ champion, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  cursor: 'pointer',
  minHeight: champion ? 50 : 40,
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    minHeight: champion ? 45 : 30,
  },
  '& .lnk': {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  '& .score': {
    fontSize: fontSizes.semiLarge,
    fontWeight: 700,
    color: colors.white,
    marginRight: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& img': {
    width: 20,
    margin: '0 3px',
    [theme.breakpoints.down('sm')]: {
      width: 12,
    },
  },
  '& a': {
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .seed': {
      fontSize: '0.7rem',
      color: colors.white,
      marginRight: 5,
    },
    '& .name': {
      fontSize: '0.8rem',
      color: colors.white,
      fontWeight: 700,
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.6rem',
      },
    },
  },
}))

export const MatchupTeam = styled('div')<BracketProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  cursor: 'pointer',
  '& .seed': {
    fontSize: fontSizes.small,
    color: colors.white,
    marginRight: 5,
    [theme.breakpoints.down('sm')]: {
      marginRight: 2,
      fontSize: fontSizes.xSmall,
    },
  },
  '& .name': {
    fontSize: fontSizes.small,
    color: colors.white,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
      fontWeight: 500,
    },
  },
}))

export const WeekStyle = styled('div')<BracketProps>(({ champion, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  cursor: 'pointer',
  minHeight: champion ? 50 : 40,
  width: '100%',
  '& img': {
    width: 20,
    margin: '0 3px',
    [theme.breakpoints.down('sm')]: {
      width: 12,
    },
  },
  '& a': {
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .seed': {
      fontSize: '0.7rem',
      color: colors.text,
      marginRight: 5,
    },
  },
}))

export const MatchupAction = styled('div')<BracketProps>(({ live, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  background: live ? colors.green : colors.gray.gray40,
  '& a': {
    margin: 5,
    color: live ? colors.black : colors.blue,
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: 700,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem',
    },
  },
}))

export const GamesCol = styled('div')<BracketProps>(({ justify, offset, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: justify,
  margin: theme.spacing(0),
  '& .weekCon': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: offset ? theme.spacing(4) : theme.spacing(0),
    '& h3': {
      fontSize: fontSizes.medium,
      fontWeight: 700,
      color: colors.white,
      marginBottom: 0,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
        marginBottom: 3,
      },
    },
    '& p': {
      marginTop: 1,
      marginBottom: 2,
      fontSize: fontSizes.small,
      color: colors.white,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  },
}))

export const FinalScoreCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  background: colors.lightGrey,
  width: '100%',
  '& img': {
    width: 20,
    margin: '1px',
    [theme.breakpoints.down('sm')]: {
      width: 12,
      margin: '0 1px',
    },
  },
  '& p': {
    margin: 5,
    fontSize: '1rem',
    fontWeight: 600,
    color: colors.text,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem',
    },
  },
}))

export const GamesOuter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  '& .gamesRow': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

export const BracketDivider = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 57,
  margin: theme.spacing(0),
  [theme.breakpoints.down('sm')]: {
    height: 20,
  },
  '& span': {
    height: 2,
    width: 30,
    [theme.breakpoints.down('sm')]: {
      width: 10,
    },
  },
}))
